import type { Address } from '~/common/components/addresses/model'

import type { ServicePointVendorAddressDto } from '~/modules/servicepointvendors/model'

export const convertToServicepointVendorAddressDto = ({
  houseNumber,
  houseNumberSuffix,
  postalCode,
  countryCode,
  ...address
}: Address): ServicePointVendorAddressDto => ({
  ...address,
  houseNumber,
  houseNumberAddition: houseNumberSuffix,
  postalCode,
  country: countryCode,
})
